import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";

const AutoLogin = () => {
    const { params } = useParams();
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_Baseurl;

    useEffect(() => {
        const performAutoLogin = async () => {
            try {
                let href = window.location.href;
                console.log("Auto-login: Full URL captured:", href);

                // Privacy: Immediately clear the URL from the browser history/address bar
                if (window.history.replaceState) {
                    window.history.replaceState(null, "Auto Login", "/login-processing");
                }

                const getValue = (url, key) => {
                    const startIndex = url.indexOf(key + ':');
                    if (startIndex === -1) return "";
                    const startValue = startIndex + key.length + 1;
                    let endIndex = url.indexOf(',', startValue);
                    if (endIndex === -1) endIndex = url.length;
                    return decodeURIComponent(url.substring(startValue, endIndex));
                };

                // Check if the parameter might be Base64 encoded
                // Example: http://localhost:1112/base64:ZW1haWw6YWRtaW5AYWRtaW4uY29tLHBhc3N3b3JkOldlYm5leHMxMjMhQCM=
                if (href.includes('base64:')) {
                    const base64Part = href.substring(href.indexOf('base64:') + 7);
                    try {
                        const decoded = atob(base64Part);
                        href = "http://fake.com/" + decoded; // Reconstruct a fake URL for shared getValue logic
                        console.log("Auto-login: Decoded Base64 parameters");
                    } catch (e) {
                        console.error("Auto-login: Failed to decode Base64", e);
                    }
                }

                const email = getValue(href, 'email');
                const password = getValue(href, 'password');

                console.log("Auto-login: Extracted Email:", email);
                console.log("Auto-login: Extracted Password:", password);

                if (!email || !password) {
                    toast.error("Invalid auto-login parameters.");
                    navigate("/login");
                    return;
                }

                const formData = {
                    email,
                    password,
                    device_id: 1,
                    device_name: "Laptop/desktop",
                    device_model: "Dell",
                    site_url: "admin"
                };

                const response = await axios.post(`${baseURL}/users/signin`, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                    }
                });

                const resData = response?.data;

                if (resData?.status) {
                    localStorage.setItem("access_token", resData?.token);
                    localStorage.setItem("user_id", resData?.user?.id);
                    localStorage.setItem("role", resData?.user?.role);
                    localStorage.setItem("username", resData?.user?.username);
                    localStorage.setItem("image_url", resData?.user?.image_url);
                    localStorage.setItem("expires_in", resData?.expires_in);
                    localStorage.setItem("user_permission", resData?.user?.user_permission);

                    toast.success("Logged in automatically!");
                    window.location.href = "/";
                } else {
                    toast.error(resData?.message || "Auto-login failed.");
                    navigate("/login");
                }
            } catch (error) {
                console.error("Auto-login error:", error);
                toast.error(error?.response?.data?.message || "Auto-login failed. Please check your credentials.");
                navigate("/login");
            }
        };

        if (params) {
            performAutoLogin();
        }
    }, [params, baseURL, navigate]);

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 theme-bg-color">
            <div className="text-center">
                <Defaultloadinggif />
                <h4 className="mt-3 theme-text-color">Logging you in automatically...</h4>
            </div>
        </div>
    );
};

export default AutoLogin;
